// Filters the "Full Walkthroughs" list on /guides as the user types.
function setup() {
  const form = document.querySelector("[data-walkthrough-search]")
  const list = document.querySelector("[data-walkthrough-list]")
  if (!form || !list) return

  const input = form.querySelector("input")
  const empty = document.querySelector("[data-walkthrough-empty]")
  const items = Array.from(list.querySelectorAll("li[data-filter-text]"))

  const filter = () => {
    const terms = input.value.trim().toLowerCase().split(/\s+/).filter(Boolean)
    let visible = 0

    items.forEach((item) => {
      const text = item.dataset.filterText
      const match = terms.every((term) => text.includes(term))
      item.hidden = !match
      if (match) visible++
    })

    if (empty) empty.hidden = visible > 0
  }

  input.addEventListener("input", filter)

  // Enter jumps straight to the walkthrough when there's a single match
  form.addEventListener("submit", (event) => {
    event.preventDefault()
    const matches = items.filter((item) => !item.hidden)
    if (matches.length === 1) {
      const link = matches[0].querySelector("a")
      if (link) window.location.href = link.href
    }
  })
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setup)
} else {
  setup()
}
